import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  answer1: {
    id: 'seo_copy_topic_description_first',
  },
  question1: {
    id: 'seo_copy_topic_title_first',
  },

  answer2: {
    id: 'seo_copy_topic_description_second',
  },
  question2: {
    id: 'seo_copy_topic_title_second',
  },

  answer3: {
    id: 'seo_copy_topic_description_third',
  },
  question3: {
    id: 'seo_copy_topic_title_third',
  },

  answerTravelEn1: {
    id: 'seo_copy_topic_travel_description_first_en',
  },
  questionTravelEn1: {
    id: 'seo_copy_topic_travel_title_first_en',
  },

  answerTravelEn2: {
    id: 'seo_copy_topic_travel_description_second_en',
  },
  questionTravelEn2: {
    id: 'seo_copy_topic_travel_title_second_en',
  },

  answerTravelEs1: {
    id: 'seo_copy_topic_travel_description_first_es',
  },
  questionTravelEs1: {
    id: 'seo_copy_topic_travel_title_first_es',
  },

  answerTravelEs2: {
    id: 'seo_copy_topic_travel_description_second_es',
  },
  questionTravelEs2: {
    id: 'seo_copy_topic_travel_title_second_es',
  },

  answerTravelEsMx1: {
    id: 'seo_copy_topic_travel_description_first_es_mx',
  },
  questionTravelEsMx1: {
    id: 'seo_copy_topic_travel_title_first_es_mx',
  },

  answerTravelEsMx2: {
    id: 'seo_copy_topic_travel_description_second_es_mx',
  },
  questionTravelEsMx2: {
    id: 'seo_copy_topic_travel_title_second_es_mx',
  },

  answerTravelFr1: {
    id: 'seo_copy_topic_travel_description_first_fr',
  },
  questionTravelFr1: {
    id: 'seo_copy_topic_travel_title_first_fr',
  },

  answerTravelFr2: {
    id: 'seo_copy_topic_travel_description_second_fr',
  },
  questionTravelFr2: {
    id: 'seo_copy_topic_travel_title_second_fr',
  },

  answerTravelIt1: {
    id: 'seo_copy_topic_travel_description_first_it',
  },
  questionTravelIt1: {
    id: 'seo_copy_topic_travel_title_first_it',
  },

  answerTravelIt2: {
    id: 'seo_copy_topic_travel_description_second_it',
  },
  questionTravelIt2: {
    id: 'seo_copy_topic_travel_title_second_it',
  },

  answerTravelJpFull1: {
    id: 'seo_copy_topic_travel_description_first_jp_full',
  },
  questionTravelJpFull1: {
    id: 'seo_copy_topic_travel_title_first_jp_full',
  },

  answerTravelJpFull2: {
    id: 'seo_copy_topic_travel_description_second_jp_full',
  },
  questionTravelJpFull2: {
    id: 'seo_copy_topic_travel_title_second_jp_full',
  },

  answerWorkDe: {
    id: 'seo_copy_topic_work_description_de',
  },
  questionWorkDe: {
    id: 'seo_copy_topic_work_title_de',
  },

  answerWorkEn: {
    id: 'seo_copy_topic_work_description_en',
  },
  questionWorkEn: {
    id: 'seo_copy_topic_work_title_en',
  },

  answerWorkEnUs: {
    id: 'seo_copy_topic_work_description_en-us',
  },
  questionWorkEnUs: {
    id: 'seo_copy_topic_work_title_en-us',
  },

  answerWorkEsMx: {
    id: 'seo_copy_topic_work_description_es_mx',
  },
  questionWorkEsMx: {
    id: 'seo_copy_topic_work_title_es_mx',
  },

  answerWorkFr: {
    id: 'seo_copy_topic_work_description_fr',
  },
  questionWorkFr: {
    id: 'seo_copy_topic_work_title_fr',
  },
});
